import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { useState } from "react";
import { validateEmail } from "../../helpers/authentication";
import styled from "styled-components";
import { InputHeader, Spacer, StyledInput } from "../../styles/CommonElements";
import Button from "../Button";
import { useSearchParams } from "react-router-dom";
import Backlink from "../Backlink";
import { useBreakpoints } from "../../lib/breakpoints";

export default function ForgotPassword({ email: filledEmail, dark = false }) {
  const [searchParams] = useSearchParams();

  const [email, setEmail] = useState(searchParams.get("email") || filledEmail);
  const [emailSent, setEmailSent] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const { isMobile } = useBreakpoints();

  const auth = getAuth();

  const onSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsSending(true);
    await sendPasswordResetEmail(auth, email);
    setIsSending(false);
    setEmailSent(true);
  };

  return (
    <Container>
      {isMobile && (
        <BackLinkWrapper>
          <Backlink to="/login" />
        </BackLinkWrapper>
      )}

      {!emailSent ? (
        <form onSubmit={onSubmit}>
          {isMobile && <WelcomeHeader>Reset password</WelcomeHeader>}
          <LoginHint $dark={dark}>
            We'll send a password reset link to your email. Please enter the
            email you use to sign in.
          </LoginHint>
          <div>
            {dark ? (
              <DarkInputHeader>Email</DarkInputHeader>
            ) : (
              <InputHeader>Email</InputHeader>
            )}
            <Spacer $marginTop="6px" />
            <InputContainer>
              {dark ? (
                <DarkStyledInput
                  className="transition-colors"
                  placeholder="you@email.com"
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                />
              ) : (
                <StyledInput
                  className="transition-colors"
                  placeholder="you@email.com"
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                />
              )}
              {/* <Checkmark src="/icons/checkmark.svg" /> */}
            </InputContainer>
            <SubmitButtons>
              <Button
                size="large"
                disabled={!(validateEmail(email) && email !== "") || isSending}
              >
                {!isSending && "Submit"}
                {isSending && <Spinner alt="" src="/icons/spinner.svg" />}
              </Button>
            </SubmitButtons>
          </div>
        </form>
      ) : (
        <>
          <LoginHint $dark={dark}>
            Thanks! Please check your inbox. We've sent an email to {email}.
          </LoginHint>
        </>
      )}
    </Container>
  );
}

const Container = styled.div`
  text-align: left;
  margin: auto;
  margin-top: 30px;
  width: 90%;
`;

/*
const Checkmark = styled.img`
  right: 14px !important;
  top: 35%;
  height: 12px;
  position: absolute;
`;
*/

const InputContainer = styled.div`
  position: relative;
`;

const WelcomeHeader = styled.div`
  font-size: 28px;
  font-weight: 800;
  line-height: 45px;
  letter-spacing: 0em;
  text-align: left;
`;

const LoginHint = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0.2px;
  text-align: left;
  margin-top: 16px;
  margin-bottom: 30px;
  color: ${(p) => (p.$dark ? "rgba(226, 232, 240, 0.92)" : "black")};
`;

const DarkInputHeader = styled.label`
  color: #cbd5e1;
  font-family: "Inter", system-ui, ui-sans-serif, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: 0.2px;
  margin-bottom: 0.5rem;
  text-align: left;
  display: block;
`;

const DarkStyledInput = styled.input`
  width: 100%;
  font-size: 1.05rem;
  padding: 0.95rem 1.1rem;
  border-radius: 0;
  border: 2px solid #475569;
  background: #020617;
  color: #f8fafc;
  font-family: var(--font-secondary, "Inter", system-ui, sans-serif);
  margin-bottom: 0.5rem;
  box-sizing: border-box;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:focus {
    outline: none;
    border-color: #ff5722;
    box-shadow: 0 0 0 1px #ff5722, 0 0 14px rgba(255, 87, 34, 0.25);
  }

  &::placeholder {
    color: rgba(148, 163, 184, 0.85);
    font-size: 1rem;
  }
`;

const SubmitButtons = styled.h4`
  font-size: 12px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0px;
  margin-bottom: 0;
  text-align: left;
  margin: auto;
  text-align: center;
  margin-top: 36px;
`;

const Spinner = styled.img`
  width: 25px;
  height: 25px;
  animation: rotation 2s infinite linear;
`;

const BackLinkWrapper = styled.div`
  margin-bottom: 20px;
`;
